import "./styles.css";
import { useState, useEffect } from "react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../../../img/logo_2.png";
import { donate } from "../../DonateUserInterface/DonateArray";
import DonateByItem from "../DonateByItem";
import { getCarrencyCurSu } from "../../../../features/CarrencyCurSuSlice/CarrencyCurSuSlice";
import ButtonHead from "../../../buttonHead";

const DonateByList = () => {
  const dispatch = useDispatch();
  const searchGameImg = useSelector((state) => state.search.searchGameImg);
  const searchGameName = useSelector((state) => state.search.searchGameName);
  const searchGameId = useSelector((state) => state.search.searchGameId);
  const searchGamePriceAr = useSelector(
    (state) => state.search.searchGamePriceAr
  );
  const searchGamePriceTr = useSelector(
    (state) => state.search.searchGamePriceTr
  );
  const isFetchingPriceTr = useSelector(
    (state) => state.search.isFetchingPriceTr
  );

  const searchGameDescription = useSelector(
    (state) => state.search.searchGameDescription
  );

  const carrencyArCurSu = useSelector(
    (state) => state.carrencyCurSu.carrencyArCurSu
  );

  useEffect(() => {
    dispatch(getCarrencyCurSu());

    // console.log(carrencyArCurSu);
  }, []);

  return (
    <div>
      {/* <div
        className="gpoup-information-deals text_decoration-red"
        style={{ marginTop: "15px" }}
      >
        Все цены актуальны, обращайтесь в
        <img className="gpoup-information-deals__logo" src={logo} />
        <a
          className="gpoup-information__title"
          href="https://vk.com/life4play1"
          target="_blank"
          rel="noopener noreferrer"
        >
          Life4Play
        </a>
      </div> */}
      <div className="gpoup-information__text" style={{ margin: "20px" }}>
        {/* <div> {`Всего ${dealsGamesListId.length} игр и dlc`}</div> */}
        <div className="gpoup-information-deals">
          {/* <img className="gpoup-information-deals__logo" src={logo} />
          <a
            className="gpoup-information__title"
            href="https://vk.com/life4play1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Life4Play
          </a> */}
          Игровая валюта
        </div>
      </div>
      {donate.map((item) => {
        return (
          <div
            key={item.id}
            className="acor-container"
            onClick={() => {
              return <></>;
            }}
          >
            <input type="checkbox" name="chacor" id={item.nameGame} />
            <label htmlFor={item.nameGame}>{item.nameGame}</label>
            <div
              className="acor-body"
              onClick={() => {
                <DonateByItem key={donate.id} {...donate} />;
              }}
            >
              {item.donate.map((donate) => {
                return <DonateByItem key={donate.id} {...donate} />;
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DonateByList;
